import script from "./keywordComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./keywordComponent.vue?vue&type=script&setup=true&lang=js"

import "./keywordComponent.vue?vue&type=style&index=0&id=7082377a&lang=css"
import "./keywordComponent.vue?vue&type=style&index=1&id=7082377a&scoped=true&lang=scss"
import "./keywordComponent.vue?vue&type=style&index=2&id=7082377a&scoped=true&lang=css"
import "./keywordComponent.vue?vue&type=style&index=3&id=7082377a&scope=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7082377a"]])

export default __exports__